import { parseJson } from '@js/utilities/response';
import { openRemoteModal } from '@js/utilities/remoteModal';
import { formFullfill } from '@js/pages/returns/returnsFormFullfill';

export const returnsStarterFormHandler = () => {
    const returnsStarterFormButton = document.querySelector('.js-returns-starter-form-button');
    const orderIdInputElement = document.querySelector('.js-order-id-input-step1');
    const orderEmailInputElement = document.querySelector('.js-order-email-input-step1');

    const productsListElements = [...document.querySelectorAll('.js-return-order-products-list')];

    returnsStarterFormButton.addEventListener('click', async (e) => {
        e.preventDefault();

        if (!orderIdInputElement.reportValidity() || !orderEmailInputElement.reportValidity()) {
            return;
        }

        const response = await fetch(
            `/api/issue/get_order_info?order_id=${orderIdInputElement.value}&email=${orderEmailInputElement.value}`
        );

        const data = await parseJson(response);

        if (response.ok) {
            formFullfill(data.order);

            const elementToInjectRemoteContent = productsListElements.find((el) =>
                el.dataset.serviceType.includes(window.returnsFormData.serviceType)
            );
            // console.log(elementToInjectRemoteContent);

            const orderProductsResponse = await fetch(
                `/api/issue/get_order_products_info?order_id=${orderIdInputElement.value}&email=${orderEmailInputElement.value}`
            );

            if (orderProductsResponse.ok) {
                const html = await orderProductsResponse.text();

                if (elementToInjectRemoteContent) {
                    elementToInjectRemoteContent.innerHTML = html;
                }

                window.dispatchEvent(new CustomEvent('RemoteContentLoaded'));

                window.returnsFormElement?.multiStepForm?.go(2);
            }

            // console.log(orderProductsResponse);
        } else {
            openRemoteModal(
                `/ajax/modals/error/default?custom_data_json=${JSON.stringify({
                    ...data,
                    phraseContext: 'returns-form',
                })}`
            );
        }
    });
};
